export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  workAchievement: 'work-achievement',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  workAchievement: {
    teamRead: 'team:read',
  },
};
